import React, { useEffect, useRef, useState } from "react";

const AnimateOnScroll = ({ children, className = "", threshold = 0.1 }) => {
  const ref = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.disconnect(); // Animate only once per element
        }
      },
      { threshold }
    );

    if (ref.current) {
      observer.observe(ref.current);
    }

    return () => observer.disconnect();
  }, [threshold]);

  return (
    <div
      ref={ref}
      className={`${className} ftco-animate ${isVisible ? "show" : ""}`}
      style={{ visibility: isVisible ? "visible" : "hidden" }}
    >
      {children}
    </div>
  );
};

export default AnimateOnScroll;
